// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-screening-forms-warning{padding:44px 0;text-align:center}", ""]);
// Exports
module.exports = exports;
